module.exports = __webpack_public_path__ + "img/compact.87588662.png";